import { NeutralColors } from 'src/theme/colors';
import styled from 'styled-components';

const PopoverContent = styled.div`
  max-height: 400px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${NeutralColors[20]};
    border-radius: 3px;
  }
`;

export { PopoverContent };
